/*
    js-polyfill.js -- Useful polyfills and globals (dump, loadJson, print, serialize)
 */

try {
    //  Needed for custom-event used by dragula
    if (typeof global !== 'undefined') {
    } else if (typeof self !== 'undefined') {
        self.global = self
    } else if (typeof window !== 'undefined') {
        window.global = window
    } else {
        let self = Function('return this')()
        self.global = self
    }
} catch (e) {}

/*
    Debug assist
 */
export function debug(profile) {
    global.dump = (...args) => {
        let s = []
        for (let item of args) {
            s.push(
                JSON.stringify(
                    item,
                    function (key, value) {
                        if (this[key] instanceof Date) {
                            return this[key].toLocaleString()
                        }
                        return value
                    },
                    4
                )
            )
        }
        print(s.join(' '))
    }
    global.print = (...args) => {
        console.log(...args)
    }
    global.assert = (a) => {
        if (!a) {
            console.log(`Assertion failed`, new Error('Assertion'), {bug: true})
            debugger
        }
    }
}

//  Warning, this does not do a deep clone
export function allow(obj, ...mask) {
    let result = {}
    if (!obj) {
        obj = {}
    }
    if (mask.length == 1 && Array.isArray(mask[0])) {
        mask = mask[0]
    }
    if (Array.isArray(mask)) {
        for (let field of mask) {
            if (obj[field] !== undefined) {
                result[field] = obj[field]
            }
        }
    } else if (typeof mask == 'string') {
        result[mask] = obj[mask]
    } else {
        for (let field of Object.keys(mask)) {
            if (obj[field] !== undefined) {
                result[field] = obj[field]
            }
        }
    }
    return result
}

export function deny(obj, ...mask) {
    let result
    if (!obj) {
        obj = {}
    }
    if (mask.length == 1 && Array.isArray(mask[0])) {
        mask = mask[0]
    }
    if (Array.isArray(mask)) {
        result = Object.assign({}, obj)
        for (let key of mask) {
            delete result[key]
        }
    } else if (typeof mask == 'string') {
        result = {}
        for (let [key, value] of Object.entries(obj)) {
            if (key != mask) {
                result[key] = value
            }
        }
        result[mask] = obj[mask]
    } else {
        result = {}
        for (let field of Object.keys(mask)) {
            if (obj[field] !== undefined) {
                result[field] = obj[field]
            }
        }
    }
    return result
}

export function isDefined(value) {
    return !(value == undefined || value === '' || value.length == 0)
}

//  Return a number with two places
export function currency(n, places = 2) {
    let factor = Math.pow(10, places)
    return (Math.round(n * factor) / factor).toFixed(places) - 0
}

//  Return a string (Can't use toLocaleString we need both commas and places)
export function money(n, places = 2) {
    let factor = Math.pow(10, places)
    let number = +(Math.round(n * factor) / factor).toFixed(places)
    let fraction = number % 1
    let fixed = Math.floor(number)
    fixed = fixed.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    if (fraction) {
        fraction = (Math.round(fraction * factor) / factor).toFixed(places).replace(/^0\./, '.')
    } else {
        fraction = ''
    }
    return fixed + fraction
}

export function isPlainObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]'
}

function getValue(path, context) {
    let parts = path.split('.')
    let prop = parts.at(-1).trim()
    for (let key of parts.slice(0, -1)) {
        key = key.trim()
        if (context[key] == null) {
            return null
        }
        context = context[key]
    }
    return context[prop]
}

/*
    Supports exanding ${key} or ${key||value} 
    FUTURE ${key ? trueValue : falseValue}
    Unexpanded tokens remain as ${key}
    If the value is an object, it is converted to a JSON string
 */
export function template(s, ...contexts) {
    if (!contexts || !s) {
        return s
    }
    for (let context of contexts) {
        if (!context) continue
        if (s.indexOf('${') < 0) {
            break
        }
        s = s.replace(/\${(.*?)}/g, (a, b) => {
            //   Default value dealt with after examining all contexts
            let [key] = b.split('||')
            let value = getValue(key, context)
            if (value) {
                if (typeof value == 'function') {
                    return value()
                } else if (isPlainObject(value)) {
                    return JSON.stringify(value)
                }
                return value
            } else {
                // Original ${token}
                return a
            }
        })
    }
    return s.replace(/\${(.*?)}/g, (a, b) => {
        let [, defaultValue] = b.split('||')
        if (defaultValue != null) {
            return defaultValue.trim()
        }
        return a
    })
}

//  Single word
export function toTitle(word) {
    return word ? word[0].toUpperCase() + word.slice(1) : ''
}

//  Multiword
export function titlecase(str) {
    if (!str) {
        return str
    }
    var words = str.toString().split(/[ \.]/g)
    for (let i = 0; i < words.length; i++) {
        words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1)
    }
    return words.join(' ')
}

export function toMap(a, property, indexed = false) {
    let result = {}
    if (property) {
        for (let i = 0; i < a.length; i++) {
            let item = a[i]
            if (indexed) {
                result[item[property]] = i
            } else {
                result[item[property]] = item
            }
        }
    } else {
        for (let i = 0; i < a.length; i++) {
            let item = a[i]
            result[item] = i
        }
    }
    return result
}

export function trap(obj, prop) {
    let actual = `_${prop}`
    obj[actual] = obj[prop]
    Object.defineProperty(obj, prop, {
        get: function () {
            return obj[actual]
        },
        set: function (value) {
            debugger
            obj[actual] = value
        },
    })
}

export function unique(a) {
    return Array.from(new Set(a))
    // return a.filter((value, index, self) => self.indexOf(value) === index)
}

export function zpad(n, size) {
    var s = n + ''
    while (s.length < size) s = '0' + s
    return s
}

export function dirname(path) {
    return path.substring(0, path.lastIndexOf('/')) || '.'
}

export function compressJson5(src, maxItems = 6, maxLen = 80) {
    if (!src) return '';
    // Strip comments
    src = src.replace(/\s*\/\/.*/g, '');

    let prev;
    // Iteratively compress, working from the inside out.
    // This loop will repeat until no more changes can be made, up to 8 times.
    for (let i = 0; i < 8; i++) {
        prev = src;

        // Regex to find a "simple" object or array: one that does not contain other objects or arrays.
        // It looks for an opening brace/bracket, followed by any characters that are NOT braces/brackets,
        // and then the corresponding closing brace/bracket. This finds the innermost structures.
        const re = /([{[])([^[{}]*?)([}\]])/g;
        src = src.replace(re, (match, open, body, close) => {
            // If the structure isn't multi-line, we don't need to change it.
            if (!match.includes('\n')) {
                return match;
            }

            // Don't modify if opening and closing braces don't match
            if ((open === '{' && close !== '}') || (open === '[' && close !== ']')) {
                return match;
            }

            const trimmedBody = body.trim();
            if (trimmedBody === '') {
                return `${open}${close}`;
            }

            // To check item count, we can split by comma.
            // This is a simplification and works for many JSON5-like structures.
            const items = trimmedBody.split(',').filter(s => s.trim());
            if (items.length > maxItems) {
                return match;
            }
            
            // Re-join items onto a single line
            const oneline = `${open} ${items.join(', ').replace(/\s+/g, ' ')} ${close}`;
            if (oneline.length > maxLen) {
                return match;
            }

            return oneline;
        });

        if (src === prev) {
            break;
        }
    }
    return src;
}

/*
Object.replace = function (dest = {}, src = {}) {
    for (let key of Object.keys(dest)) {
        if (src[key] === undefined) {
            delete dest[key]
        }
    }
    return Object.assign(dest, Object.clone(src))
}

import combine from '@/paks/js-combine'
import blend from '@/paks/js-blend'
import clone from '@/paks/js-clone'

Object.combine = combine
Object.blend = blend
Object.clone = clone

export function serialize(o, pretty = false) {
    return JSON.stringify(o, null, pretty ? 4 : 0)
}
export const toTitle = (s) => (s ? s[0].toUpperCase() + s.slice(1) : '')

export function rotate(n, places) {
    n.unshift.apply(n, this.splice(places, n.length))
    return n
} 

Number.prototype.round = function (places = 12) {
    return parseFloat(this).toPrecision(places) - 0
}

Object.keyFields = function (obj, property) {
    let result = []
    for (let [key, value] of Object.entries(obj)) {
        result.push(value[property])
    }
    return result
}

export function makeArray(a) {
    if (a != null) {
        if (Array.isArray(a)) {
            return a
        }
        return [a]
    }
    return []
}

Array.prototype.remove = function (set) {
    return this.filter((value, index, self) => set.indexOf(value) < 0)
}
*/

/*
    Polyfill Object.keys and Object.values

const reduce = Function.bind.call(Function.call, Array.prototype.reduce)
const isEnumerable = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable)
const concat = Function.bind.call(Function.call, Array.prototype.concat)

const keys = Object.keys
if (!Object.values) {
    Object.values = function values(obj) {
        return reduce(keys(obj), (v, k) => concat(v, typeof k === 'string' && isEnumerable(obj, k) ? [obj[k]] : []), [])
    }
}

if (!Object.entries) {
    Object.entries = function entries(obj) {
        return reduce(
            keys(obj),
            (e, k) => concat(e, typeof k === 'string' && isEnumerable(obj, k) ? [[k, obj[k]]] : []),
            []
        )
    }
}
if (!RegExp.toJSON) {
    RegExp.prototype.toJSON = RegExp.prototype.toString
}

export function portable(s) {
    return s.toString().replace(/\\/g, '/')
}1
*/
